import React, { Component } from 'react';
import Screenshot from './Screenshot/Screenshot';
import classes from './Screenshots.module.css'




class Screenshots extends Component {
    state = {
        selectedImageURI: null
    }

    getSelectedImageFromContainerHandler(selectedImageURI) {
        // console.log("[Screenshots]")
        this.setState({ selectedImageURI: selectedImageURI })
    }

    render() {

        const screenshots = this.props.imgURIArray.map((imgIndex, index) => {
            // console.log("[Screenshots] " + canvasIndex.canvas)
            // console.log("[Screenshots] " + canvasIndex.ref)
            return (
                <Screenshot
                    key={imgIndex + Math.random()}
                    imgIndex={imgIndex.url}
                    index={index + 1}
                    timeStamp={imgIndex.timeStamp}
                    getSelectedImageFromContainerHandler={imgURI => this.props.getSelectedImageFromContainerHandler(imgURI)}
                />
            )
        })
        return (
            <div className={classes.Screenshots}>
                {screenshots}
            </div>
        );
    }
}
export default Screenshots;